import { createFileRoute } from '@tanstack/react-router';

import { NotImplementedPage } from '@apple/ui/shell/pages/NotImplementedPage';

import { requireAuth } from '@apple/features/auth/utils/require-auth';

export const Route = createFileRoute('/_authed/_admin/manage/line-of-business')({
	beforeLoad: args =>
		requireAuth(args, {
			requirePermission: 'Manzanita.Security.Features.ProductCategoryManagement.Read',
		}),
	component: LineOfBusinessManagementRoute,
});

function LineOfBusinessManagementRoute() {
	return <NotImplementedPage name='Line of Business Management' />;
}
